// использовать импорт типов в блоках не очень хорошо
// но я не нашел другого способа адекватного прорастить типы везде
import {CountryInfo as Context} from '@yandex-delivery/types/schemas/services/cargo-corp/docs/yaml/api/country'
import {createContext} from 'react'

export type CountryInfoContextType = Context | null
export const CountryInfoContext = createContext<CountryInfoContextType>(null)
